import { defOp } from "./internal/codegen";
import { SET_N } from "./internal/templates";
export const [setN, setN2, setN3, setN4] = defOp(SET_N, "a,n", "a", "a", 0, "");
export const zero = (a) => setN(a, 0);
export const one = (a) => setN(a, 1);
export const zeroes = (n) => new Array(n).fill(0);
export const ones = (n) => new Array(n).fill(1);
